"use client";
import React, { useEffect, useState } from "react";
import Script from "next/script";

import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";

export const ClarityScript = ({ userId = "", apiKey, isUserLoading }) => {
  const [loaded, setLoaded] = useState(false);

  const onLoad = () => {
    const clarityScript = document.querySelectorAll(
      "[src$='clarity.js'], [src$='web-performance.js']",
    );
    if (clarityScript[0]) {
      clarityScript[0].onload = () => setLoaded(true);
    }
  };
  useEffect(() => {
    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity?.q || []).push(arguments);
      };
  }, [loaded]);

  useEffect(() => {
    if (!isUserLoading && loaded) {
      getFingerprint()
        .then((sessionId) => {
          window.clarity?.("set", "userId", userId);
          window.clarity?.("set", "sessionId", sessionId);
          window.clarity?.("identify", userId, sessionId);
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.error(e));
    }
  }, [isUserLoading, userId, loaded]);

  return (
    <Script
      type="text/javascript"
      id="clarity-script"
      onLoad={onLoad}
      src={`https://www.clarity.ms/tag/${apiKey}`}
      strategy="lazyOnload"
      async
    />
  );
};

export const ClarityWrapper = ({ userId = "", apiKey, isUserLoading }) => {
  if (!apiKey) return null;
  return <ClarityScript userId={userId} apiKey={apiKey} isUserLoading={isUserLoading} />;
};
